import react from "react";
import styled from "styled-components";
import {
  scaleInCenter,
  scaleUpCenter,
  rotateScaleUp,
} from "./styled/animations";
import shinnyEffectImage from "../assets/images/background/shinnybackground.png";
import legendaryImage from "../assets/images/rarities/legendary.svg";
import normalImage from "../assets/images/rarities/normal.svg";
import rareImage from "../assets/images/rarities/rare.svg";
import uniqueImage from "../assets/images/rarities/unique.svg";
import mysticImage from "../assets/images/rarities/mystic.svg";
import ProductBuySection from "./productBuySection";
import { RarityBox } from "./RarityBox";
import ReactMarkdown from "react-markdown";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  padding-bottom: 115px;
`;

const ProductImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
`;
const ShinnyEffectImage = styled.img`
  position: absolute;
  bottom: 0;
  z-index: -1;
  animation: ${scaleUpCenter} 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) 0.5s both;
`;

const ProductImage = styled.img`
  width: 100%;
  max-width: calc(40 * var(--vw));
  animation: ${scaleInCenter} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  -webkit-animation: ${scaleInCenter} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
`;

const RaritiesContainer = styled.div`
  display: flex;
  height: 7vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 9px;
`;
const RarityImage = styled.img`
  width: auto;
  height: 100%;
  animation: ${rotateScaleUp} 0.65s linear both;
`;
const LimitedArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60px;
  gap: 4px;
  width: 60%;
  margin-top: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
`;
const ProductDescription = styled.div`
  width: 80%;
  padding: 16px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  border-radius: 8px;
  text-align: center;
  margin-top: 8px;
  ul {
    list-style-type: disc;
    padding-left: 16px;
    li {
      margin-bottom: 4px;
      font-size: 14px;
    }
  }
`;
const ProductContainer = ({ product }) => {
  const [loaded, setLoaded] = react.useState(false);

  if (!product?.item.imageUri) {
    return null;
  }
  return (
    <Container>
      <ProductImageContainer>
        <ProductImage
          onLoad={() => setLoaded(true)}
          src={product?.item.imageUri}
        />
        {loaded && <ShinnyEffectImage src={shinnyEffectImage} />}
      </ProductImageContainer>
      <RaritiesContainer>
        <RarityBox src={normalImage} tooltipText="Normal" />
        <RarityBox src={rareImage} tooltipText="Rare" />
        <RarityBox src={uniqueImage} tooltipText="Unique" />
        <RarityBox src={legendaryImage} tooltipText="Legendary" />
        {product.isLimited && (
          <RarityBox src={mysticImage} tooltipText="Mystic" />
        )}
      </RaritiesContainer>
      {product?.isLimited && (
        <LimitedArea>
          <span style={{ color: "white", fontSize: "16px" }}>
            Limit count: <strong>{product.limitCount}</strong>
          </span>
          <span style={{ color: "white", fontSize: "16px" }}>
            Sold amount:
            <strong>
              {" "}
              {product.soldAmount >= product.limitCount
                ? "Sold out"
                : product.soldAmount}
            </strong>
          </span>
        </LimitedArea>
      )}
      {product?.item.items && (
        <>
          <ProductDescription>
            <h3
              style={{ color: "white", fontSize: "24px", marginBottom: "16px" }}
            >
              <strong>{product.item.name}</strong>
            </h3>
            <ReactMarkdown>{product.item.description}</ReactMarkdown>
          </ProductDescription>
          {product?.isLimited && (
            <LimitedArea>
              <span style={{ color: "white", fontSize: "16px" }}>
                Limit count: <strong>{product.limitCount}</strong>
              </span>
              <span style={{ color: "white", fontSize: "16px" }}>
                Sold amount:
                <strong>
                  {" "}
                  {product.soldAmount >= product.limitCount
                    ? "Sold out"
                    : product.soldAmount}
                </strong>
              </span>
            </LimitedArea>
          )}
        </>
      )}
      <ProductBuySection product={product} />
    </Container>
  );
};

export default ProductContainer;
